import { render, staticRenderFns } from "./reportePerseoIndividual.vue?vue&type=template&id=2d6d40cb&scoped=true"
import script from "./reportePerseoIndividual.vue?vue&type=script&lang=js"
export * from "./reportePerseoIndividual.vue?vue&type=script&lang=js"
import style0 from "./reportePerseoIndividual.vue?vue&type=style&index=0&id=2d6d40cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6d40cb",
  null
  
)

export default component.exports